import React, { useEffect } from "react";
import { Modal, Form, Input } from "antd";
import { KlearlyAPKConfig } from "../../../../interfaces/klearlyApkConfig.interface";

type DepKey = keyof KlearlyAPKConfig["rapydCoreVersion"];

export default function RapydCoreEditorModal({
  open,
  depKey,
  dependency,
  loading,
  onCancel,
  onSave,
}: {
  open: boolean;
  depKey: DepKey | null;
  dependency?: KlearlyAPKConfig["rapydCoreVersion"][DepKey];
  loading: boolean;
  onCancel: () => void;
  onSave: (values: { name: string }) => void;
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    form.setFieldsValue({ name: dependency?.name });
  }, [open, dependency, form]);

  return (
    <Modal
      title={dependency?.name ? `Edit ${dependency?.name}` : "Edit Rapyd Core"}
      open={open}
      onOk={() => form.submit()}
      onCancel={onCancel}
      okButtonProps={{ loading }}
      destroyOnClose
    >
      <Form layout="vertical" form={form} onFinish={onSave}>
        <Form.Item
          label="Name/Version"
          name="name"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}
